import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../services/store';
import { PURGE } from 'redux-persist';

const initialState = {
  menu: '',
};

export const infoSlice = createSlice({
  name: 'info',
  initialState,
  reducers: {
    menuChanged: (state, action) => {
      state.menu = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  },
});

export const { menuChanged } = infoSlice.actions;

export const selectMenu = (state: RootState) => state.info.menu;

export default infoSlice.reducer;
